<template>
  <div class="address-create">
    <span class="address-create__title">{{ isEditMode ? "Редактировать адрес" : "Добавить адрес" }}</span>
    <div class="address-create__form">
      <InputComponent
        v-model="form.address.value"
        :error="form.address.error"
        title="Адрес дома"
        @input="onAddressInput"
      />
      <span class="address-create__hint" v-if="!premiseNumber && form.address.value">
        Укажите точку в пределах населенного пункта или уточните адрес
      </span>
      <div class="address-create__form-row">
        <InputComponent
          v-model="form.apartment.value"
          :error="form.apartment.error"
          title="Квартира / Офис"
        />
        <CheckboxComponent
          :checked="form.private_house.value"
          @change="form.private_house.value = !form.private_house.value"
        >
          <span> Частный дом </span>
        </CheckboxComponent>
      </div>
      <span>Дополнительная информация для курьера</span>
      <div class="address-create__form-row">
        <InputComponent v-model="form.entrance.value" :error="form.entrance.error" title="Подъезд" />
        <InputComponent v-model="form.intercom.value" :error="form.intercom.error" title="Домофон" />
        <InputComponent v-model="form.floor.value" :error="form.floor.error" title="Этаж" />
      </div>
      <button @click="submit" class="btn btn--md btn--main" :disabled="!premiseNumber">
        <FileIconComponent v-if="loading" name="loading" />
        <template v-else>{{ isEditMode ? "Сохранить" : "Добавить адрес" }}</template>
      </button>
    </div>
  </div>
</template>

<script>
import ADDRESS_CREATE from "gql/mutations/AddressCreate.graphql";
import ADDRESS_UPDATE from "gql/mutations/AddressUpdate.graphql";
import InputComponent from "components/inputs/InputComponent.vue";
import CheckboxComponent from "components/inputs/CheckboxComponent.vue";
import FileIconComponent from "components/FileIconComponent.vue";

export default {
  name: "AddressCreateForm",
  components: { FileIconComponent, CheckboxComponent, InputComponent },
  props: {
    address: String,
    premiseNumber: [String, Number],
    editAddress: Object,
  },
  computed: {
    isEditMode() {
      return !!this.editAddress;
    },
  },
  data() {
    return {
      loading: false,
      debounceTimer: null,
      form: {
        home: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        address: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        apartment: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        entrance: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        intercom: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        floor: {
          value: undefined,
          error: undefined,
          message: undefined,
        },
        private_house: {
          value: false,
          error: undefined,
          message: undefined,
        },
      },
    };
  },
  watch: {
    premiseNumber() {
      this.form.home.value = this.premiseNumber;
    },
    address() {
      this.form.address.value = this.address;
    },
  },
  mounted() {
    if (this.editAddress) {
      this.form.address.value = this.editAddress.address;
      this.form.apartment.value = this.editAddress.apartment;
      this.form.entrance.value = this.editAddress.entrance;
      this.form.intercom.value = this.editAddress.intercom;
      this.form.floor.value = this.editAddress.floor;
      this.form.private_house.value = this.editAddress.private_house || false;
    }
  },
  methods: {
    onAddressInput(value) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        if (value && value.length > 5) {
          this.$emit("address-input", value);
        }
      }, 500);
    },
    submit() {
      if (!this.loading) {
        this.loading = true;
        const mutation = this.isEditMode ? ADDRESS_UPDATE : ADDRESS_CREATE;
        const variables = {
          address: this.form.address.value,
          apartment: this.form.apartment.value,
          entrance: this.form.entrance.value,
          intercom: this.form.intercom.value,
          floor: this.form.floor.value,
          private_house: this.form.private_house.value,
        };
        if (this.isEditMode) {
          variables.id = this.editAddress.id;
        }
        this.$apollo.provider.defaultClient
          .mutate({
            mutation,
            variables,
            context: {
              headers: {
                Authorization: "Bearer " + this.$store.state.apollo_token,
              },
            },
          })
          .then(({ data }) => {
            this.$store.dispatch("GET_ADDRESSES", {
              apollo: this.$apollo,
            });
            this.loading = false;
            const result = data.AddressCreate || data.AddressUpdate;
            if (result) {
              this.$notify({
                title: "Успешно",
                text: result.message,
                type: "success",
              });
              this.$emit("close");
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="stylus">
.address-create {
  position absolute
  left 9px
  top 8px
  display flex
  flex-direction column
  gap 20px
  padding 30px
  background var(--white)
  box-shadow: 0 20px 30px var(--black_o15);
  border-radius: var(--main_radius)
  width 100%
  max-width 450px

  &__title {
    font-weight: 700;
    font-size: 1.5em
    line-height: 115%
  }

  &__form {
    display flex
    flex-direction column
    grid-gap 20px

    &-row {
      display flex
      align-items flex-end;
      gap 20px

      .check {
        margin-bottom: 16px;
      }
    }

    .btn {
      align-self flex-start
    }
  }

  &__error {
    color var(--red)
  }

  &__hint {
    color var(--body-color)
    font-size 0.875em
  }
}
</style>
